import * as locales from 'date-fns/locale';

export function useLocale(language: string): Locale {
  const localeCode = language.substring(0, 2).toLowerCase();
  const localeCodeFixed = localeCode === 'no' ? 'nb' : localeCode;

  return locales[localeCodeFixed] ?? locales.enUS;
}
